import {VendorApprovalRule} from 'src/openapi/admin/models/VendorApprovalRule';

export const formatStatus = (status?: VendorApprovalRule['entitlementStatus']) => {
    switch (status) {
        case 'ALLOW':
            return 'Allow';
        case 'DENY':
            return 'Deny';
        default:
            return '';
    }
};
